export const createDomainScopedSelector = (domainName, initialState = {}) => (state) => state[domainName] || initialState;